import React, { useMemo } from 'react';
import { withStyles } from '@glu/theming';
import { useAppConfig } from '../appConfig/AppConfig';

export default function withAppStyles({ native, web }, component) {
  return (props) => {
    const { isWeb } = useAppConfig();
    const WithAppStyles = useMemo(
      () => (isWeb ? withStyles(web)(component) : withStyles(native)(component)),
      [isWeb]
    );
    return <WithAppStyles {...props} />;
  };
}
